import { httpClient } from '@/lib/httpClient';

export enum ModelService {
  CREATE_NAME = 'CREATE_NAME',
  TONE_OF_VOICE = 'TONE_OF_VOICE',
}

export interface Model {
  id: number;
  service: ModelService;
  modelVersion: string;
  promptId: string | number;
  promptName?: string;
  customerId: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface FilterModelsDto {
  serviceName?: string;
  promptName?: string;
  page?: number;
  limit?: number;
}

export interface ModelsResponse {
  currentPage: number;
  totalItems: number;
  totalPages: number;
  items: Model[];
}

export interface CreateModelDto {
  service: string;
  modelVersion: string;
  promptId: number; // prompt id
  customerId: number;
}

export interface UpdateModelDto {
  service?: string;
  modelVersion?: string;
  promptId?: number; // prompt id for update
  customerId?: number;
}

export interface CreateModelResponse {
  id?: string | number;
  created?: boolean;
}

class ModelsService {
  constructor() {}

  async getModels(filter: FilterModelsDto): Promise<ModelsResponse> {
    const result = await httpClient.get(`/v1/models`, {
      params: {
        serviceName: filter.serviceName,
        promptName: filter.promptName,
        page: filter.page,
        limit: filter.limit,
      },
    });
    return result.data;
  }

  async createModel(createModelDto: CreateModelDto) {
    const { data } = await httpClient.post<CreateModelResponse>(
      `/v1/models`,
      createModelDto,
    );
    return data;
  }

  async updateModel(id: number, dto: UpdateModelDto) {
    const { data } = await httpClient.patch<Model>(`/v1/models/${id}`, dto);

    return data;
  }

  async removeModel(id: number) {
    const { status } = await httpClient.delete(`/v1/models/${id}`);
    return status === 204 || status === 200;
  }
}

export default new ModelsService();
